export const successMessage = (param?: string) => {
  return {
    REGISTRATION_SUCCESS: "User registration is Successfull",
    OTP_SENT: "OTP sent to your email" + param ? param : "",
    OTP_VERIFIED: "OTP Verified Successfully",
    PASSWORD_CHANGED: "Password Changed Succesfully !!",
    BUNIT_CREATION: "Facility Created Successfully !!",
    BUNIT_UPDATION: "Facility Updated Successfully !!",
    PROFILE_UPDATE_SUCCESS: "Profile Updated Successfully !!",
    EMISSION_UPDATE_SUCCESS: "Emission Log Updated Successfully !!",
    GENERATE_SUCCESS: "Report Generated Successfully !!",
    EMISSION_SUCCESS:
      "The emission log was created successfully. Please find a quick summary of emissions value and log details below",
  };
};
export const dashBoardMessage = (param?: string) => {
  return {
    CONTENT1: "Scope-wise total GHG emissions for the organization",
    CONTENT2: "GHG emissions for the organization with ISO category breakup",
    CONTENT3: "Total GHG emissions split across ISO categories",
  };
};

export const errorMessage = () => {
  return {
    EMAIL_INVALID_REGEX_ERROR: "Invalid email",
    EMAIL_INVALID_COMPANY_ERROR: "Use Only Company Emails For Registration",
    PASSWORD_LENGTH_ERROR: "Password Length should greater than or equal to 8",
    PASSWORD_MISMATCH: "Passwords do not Match",
    REGISTRATION_FORMAT:
      "Registration Id Should be 3 - 50 digit Alphanumeric, and without spaces",
    BUSINESS_UNIT_NAME_ERROR: "Facility name should have 3-50 characters.",
    STRONG_PASSWORD_REGEX_ERROR:
      "Password must be of minimum 8 characters long with minimum 1 uppercase letter, 1 numeric and 1 special character.",
    INDUSTRY_TYPE_ERROR: "Industry type must be selected",
    PHONE_ERROR: "Enter valid phone number",
    CUSTOM_EMISSION_ERROR:
      "Activity type is already created with the given source name",
  };
};
